import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";

export const addUsers = (data: any) => {
    return postApi(constants.urls.USERS_ADD, data);
};

export const editUsers = (data: any, id: string) => {
    return putApi(constants.urls.USERS_EDIT + "/" + id, data);

};

export const usersStatus = (id:any, flag:any) => {
  return putApi(constants.urls.USERS_STATUS + "/" + id+"/"+flag, {});

};

export const getPatientlistcount = () => {
  return getApi(constants.urls.PATIENT_COUNT);
};

export const listUsers = (params: string = "") => {
    return getApi(constants.urls.USERS_LIST, params);

};
export const deleteUsers = (id: string) => {
    return deleteApi(constants.urls.USERS_DELETE + "/" + id+"?hard=true");
};


export const getByUsersId = (id: string) => {
    return getApi(constants.urls.USERS_GETBYID + "/" + id);
};

export const rollbackUser = (id: string) => {
  return deleteApi(constants.urls.USERS_DROPDOWN + "/" + id);
};

export const userDropdown = () => {
  return getApi(constants.urls.USERS_DROPDOWN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

export const userDropdownHandyman = () => {
  return getApi(constants.urls.USERS_DROPDOWN_HANDYMAN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

 export const getstatus = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:0,
            label:"Inactive"
          },
          {
            id:1,
            label:"Active"
          }
        ])
      })
    })
  }

  export const getRole = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:1,
            label:"Admin"
          },
          {
            id:2,
            label:"User"
          },
        ])
      })
    })
  }